import Dexie from 'dexie'

import { tablesHeaders } from './'
import { TablesHeaders } from '../../types'

export const handleCheckIfDatabaseExists = async () => {
  const dbExists = await Dexie.exists('adamo-pay')
  return dbExists
}

export const handleDeleteExistingDatabase = (dbName: string) => {
  return new Promise((resolve, reject) => {
    try {
      Dexie.delete(dbName)
      resolve(true)
    } catch (error) {
      reject(new Error('The database was nos deleted.'))
    }
  })
}

export const handleCreateEmptyDatabase = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const db = new Dexie('adamo-pay')
      const dbStructure = handleGetDatabaseStructure()
      db.version(1).stores(dbStructure)

      window.sessionStorage.setItem('dbTables', JSON.stringify(dbStructure))
      window.sessionStorage.setItem('dbVersion', '1')
      resolve(true)
    } catch (error) {
      console.log(error)
      reject(new Error('There was an error creating the table.'))
    }
  })
}

export const handleCreateDatabase = (tablesStructure: { [tableName: string]: string | null }, tableName: string, tableKeys: string, dataToSet: Array<object> | object) => {
  return new Promise(async (resolve, reject) => {
    try {
      const db = new Dexie('adamo-pay')

      db.version(1).stores(tablesStructure)

      window.sessionStorage.setItem('dbTables', JSON.stringify(tablesStructure))
      window.sessionStorage.setItem('dbVersion', '1')

      const dataObjectToAdd: any = {}
      tableKeys.split(',').map((keyName: string) => (dataObjectToAdd[keyName] = ''))

      const dbStatus = await db.open().then((dbStatus) => dbStatus)

      if (Array.isArray(dataToSet)) {
        for (let i = 0; i < dataToSet.length; i++) {
          const registryToSet: any = dataToSet[i]
          const keysOfRegistryToSet = Object.keys(dataToSet[i])

          keysOfRegistryToSet.map((keyName: string) => (dataObjectToAdd[keyName] = registryToSet[keyName]))
          dbStatus.table(tableName).add(dataObjectToAdd)
        }
      } else {
        const registryToSet: any = dataToSet
        const keysOfRegistryToSet = Object.keys(dataToSet)

        keysOfRegistryToSet.map((keyName: string) => (dataObjectToAdd[keyName] = registryToSet[keyName]))
        dbStatus.table(tableName).add(dataObjectToAdd)
      }

      await db.close()
      resolve(true)
    } catch (error) {
      console.log(error)
      reject(new Error('There was an error creating the table.'))
    }
  })
}

export const handleSetDataToTable = (tableName: string, tableKeys: string, dataToSet: Array<object> | object) => {
  return new Promise(async (resolve, reject) => {
    try {
      const databaseExists = await handleCheckIfDatabaseExists()

      if (!databaseExists) {
        const dbStructure = handleGetDatabaseStructure()
        await handleCreateDatabase(dbStructure, tableName, tableKeys, dataToSet)
        resolve(true)
        return
      }

      const dataObjectToAdd: any = {}
      tableKeys.split(',').map((keyName: string) => (dataObjectToAdd[keyName] = ''))

      const db = new Dexie('adamo-pay')
      const dbStructure = handleGetDatabaseStructure()
      const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
      await db.close()
      // const newDbVersion = currentDbVersion + 1
      // db.version(newDbVersion).stores(dbStructure)
      db.version(currentDbVersion).stores(dbStructure)

      const { tables } = await db.open().then((dbStatus) => dbStatus)
      await db.close()
      const tableExists = tables.find((tableData) => tableData.name === tableName)

      if (!tableExists) {
        await handleCreateNewDatabaseTable(tableName, tableKeys, dataToSet)
        resolve(true)
        return
      }

      const dbStatus = await db.open().then((dbStatus) => dbStatus)

      if (Array.isArray(dataToSet)) {
        for (let i = 0; i < dataToSet.length; i++) {
          const registryToSet: any = dataToSet[i]
          const keysOfRegistryToSet = Object.keys(dataToSet[i])

          keysOfRegistryToSet.map((keyName: string) => (dataObjectToAdd[keyName] = registryToSet[keyName]))

          const tableNameRequested = dbStatus.table(tableName)
          const checkIfRegistryExists = await tableNameRequested.where('_id').equals(dataObjectToAdd._id).toArray()

          if (checkIfRegistryExists.length === 0) {
            await dbStatus.table(tableName).add(dataObjectToAdd)
          }
        }
      } else {
        const registryToSet: any = dataToSet
        const keysOfRegistryToSet = Object.keys(dataToSet)

        keysOfRegistryToSet.map((keyName: string) => (dataObjectToAdd[keyName] = registryToSet[keyName]))

        const tableNameRequested = dbStatus.table(tableName)
        const checkIfRegistryExists = await tableNameRequested.where('_id').equals(dataObjectToAdd._id).toArray()

        if (checkIfRegistryExists.length === 0) {
          await dbStatus.table(tableName).add(dataObjectToAdd)
        }
      }

      await db.close()
      resolve(true)
    } catch (error: any) {
      console.log(error, error.message)
      if (error.message && error.message.indexOf('Key already exists in the object store') !== -1) {
        resolve(true)
      } else {
        reject(new Error('There was an error creating the table.'))
      }
    }
  })
}

export const handleGetDataFromTable = (tableName: string): Promise<Array<object>> => {
  return new Promise(async (resolve, reject) => {
    const db = new Dexie('adamo-pay')

    try {
      const dbStructure = handleGetDatabaseStructure()
      const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
      await db.close()
      db.version(currentDbVersion).stores(dbStructure)

      const dbStatus = await db.open().then((dbStatus) => dbStatus)
      const tableNameRequested = dbStatus.table(`${tableName}`)
      // const tableDataSortted = await tableNameRequested.toArray()
      const tableDataSortted = await handleGetDataOfTable(tableNameRequested)

      await db.close()
      resolve(tableDataSortted)
    } catch (error: any) {
      if (error.message?.indexOf('Table') !== -1 && error.message?.indexOf('does not exist') !== -1) {
        console.log('Restarting table', tableName, (tablesHeaders as any)[`${tableName}`].join(','))
        await handleCreateNewDatabaseTable(tableName, (tablesHeaders as any)[`${tableName}`].join(','), {})
        await handleDeleteDataByOne(tableName, '')

        if (db.isOpen()) {
          await db.close()
        }

        resolve([])
        return
      }

      if (error.message?.indexOf('Database') === -1) {
        console.log(error)
      }

      reject(error)
    }
  })
}

const handleGetDataOfTable = async (tableRequested: any) => {
  try {
    const tableDataSortted = await tableRequested.toArray()
    return tableDataSortted
  } catch (error) {
    console.log(error)
    await tableRequested.clear()
  }
}

export const handleGetDataFromTableById = async (tableName: string, idToFind: string) => {
  return new Promise(async (resolve, reject) => {
    const db = new Dexie('adamo-pay')

    try {
      const dbStructure = handleGetDatabaseStructure()
      const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
      await db.close()
      db.version(currentDbVersion).stores(dbStructure)

      const dbStatus = await db.open().then((dbStatus) => dbStatus)
      const tableNameRequested = dbStatus.table(tableName)
      const dataRequested = await tableNameRequested.where('_id').equals(idToFind).toArray()

      await db.close()
      resolve(dataRequested)
    } catch (error: any) {
      if (error.message?.indexOf('Table') !== -1 && error.message?.indexOf('does not exist') !== -1) {
        console.log('Restarting table', error.message)
        await handleCreateNewDatabaseTable(tableName, (tablesHeaders as any)[`${tableName}`].join(','), {})

        await handleDeleteDataByOne(tableName, '')

        if (db.isOpen()) {
          await db.close()
        }

        const dbStatus = await db.open().then((dbStatus) => dbStatus)
        const tableNameRequested = dbStatus.table(`${tableName}`)
        const tableDataSortted = await tableNameRequested.toArray()

        await db.close()
        resolve(tableDataSortted)
        return
      }

      if (error.message === 'Database adamo-pay doesnt exist') {
        resolve([])
        return
      }

      console.log('tableName', tableName)
      console.log(error)

      reject(new Error('Error al obtener los datos de la tabla.'))
    }
  })
}

export const handleGetDataFromTableByAttribute = async (tableName: string, attribute: string, attributeValueToFind: string | Array<string>) => {
  return new Promise(async (resolve, reject) => {
    try {
      const db = new Dexie('adamo-pay')

      const dbStructure = handleGetDatabaseStructure()
      const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
      await db.close()
      db.version(currentDbVersion).stores(dbStructure)

      const dbStatus = await db.open().then((dbStatus) => dbStatus)
      const tableNameRequested = dbStatus.table(tableName)
      const dataRequested = Array.isArray(attributeValueToFind)
        ? await tableNameRequested.where(attribute).anyOf([attributeValueToFind]).toArray()
        : await tableNameRequested.where(attribute).equals(attributeValueToFind).toArray()

      await db.close()
      resolve(dataRequested)
    } catch (error: any) {
      console.log(error)

      if (error.message.indexOf('Table') !== -1 && error.message.indexOf('does not exist') !== -1) {
        console.log('agarro el error')

        await handleCreateNewDatabaseTable(tableName, (tablesHeaders as any)[`${tableName}`].join(','), {})
        await handleDeleteDataByOne(tableName, '')
        resolve([])
        return
      }

      reject(new Error('Error al obtener los datos de la tabla.'))
    }
  })
}

export const handleGetDataFromTableByIdAndAttribute = async (tableName: string, idToFind: string, attribute: string, attributeValueToFind: string | number) => {
  return new Promise(async (resolve, reject) => {
    try {
      const db = new Dexie('adamo-pay')

      const dbStructure = handleGetDatabaseStructure()
      const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
      await db.close()
      db.version(currentDbVersion).stores(dbStructure)

      const dbStatus = await db.open().then((dbStatus) => dbStatus)
      const tableNameRequested = dbStatus.table(tableName)
      const dataRequested = await tableNameRequested
        .where('_id')
        .equals(idToFind)
        .and((item) => item[attribute] === attributeValueToFind)
        .toArray()

      await db.close()
      resolve(dataRequested)
    } catch (error) {
      console.log(error)
      reject(new Error('Error al obtener los datos de la tabla.'))
    }
  })
}

export const handleUpdateDataByOne = async (tableName: string, idToUpdate: string, dataToChange: object) => {
  return new Promise(async (resolve, reject) => {
    try {
      const db = new Dexie('adamo-pay')

      const dbStructure = handleGetDatabaseStructure()
      const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
      await db.close()
      db.version(currentDbVersion).stores(dbStructure)

      const dbStatus = await db.open().then((dbStatus) => dbStatus)
      const tableNameRequested = dbStatus.table(tableName)
      const dataUpdated = await tableNameRequested.where('_id').equals(idToUpdate).modify(dataToChange)
      console.log('dataUpdated', dataUpdated, 'tableName', tableName)

      await db.close()
      resolve(true)
    } catch (error) {
      console.log(error)
      reject(new Error('Error al obtener los datos de la tabla.'))
    }
  })
}

export const handleDeleteDataByOne = (tableName: string, idToDelete: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const databaseExists = await handleCheckIfDatabaseExists()

      if (!databaseExists) {
        resolve(true)
      }

      const db = new Dexie('adamo-pay')
      const dbStructure = handleGetDatabaseStructure()
      const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
      await db.close()
      // db.version(currentDbVersion + 1).stores(dbStructure)
      db.version(currentDbVersion).stores(dbStructure)

      const tableNameRequested = await db.open().then((dbStatus) => dbStatus.table(tableName))
      // const tableNameRequested = dbStatus.table(tableName)
      const dataDeleted = await tableNameRequested.delete(idToDelete)
      console.log('dataDeleted', dataDeleted, tableName, idToDelete)

      await db.close()
      resolve(true)
    } catch (error) {
      console.log(error)
      reject(new Error('Error al obtener los datos de la tabla.'))
    }
  })
}

export const handleGetDatabaseTablesStructure = () => {
  const databaseTablesStructure: any = {}
  const tablesNames = Object.keys(tablesHeaders)

  for (let i = 0; i < tablesNames.length; i++) {
    databaseTablesStructure[tablesNames[i]] = (tablesHeaders as any)[tablesNames[i]].join(',').replaceAll(' ', '')
  }

  return databaseTablesStructure
}

const handleCreateNewDatabaseTable = (tableName: string, tableKeys: string, dataToSet: Array<object> | object) => {
  return new Promise(async (resolve) => {
    const currentDatabaseData: any = await handleGetCurrentDatabaseData()

    const databaseNewVersionToStore: any = {}
    const currentDatabaseTables = Object.keys(currentDatabaseData)
    const currentDatabaseTablesLength = currentDatabaseTables.length

    for (let i = 0; i < currentDatabaseTablesLength; i++) {
      databaseNewVersionToStore[currentDatabaseTables[i]] = (tablesHeaders as any)[currentDatabaseTables[i]].join(',')
    }

    databaseNewVersionToStore[tableName] = tableKeys
    const dbStructure = handleGetDatabaseStructure()

    const db = new Dexie('adamo-pay')
    const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
    await db.close()
    db.version(currentDbVersion).stores(dbStructure)

    let dbStatus = await db.open().then((dbStatus) => dbStatus)
    await db.close()
    const newDbVersion = dbStatus.verno + 1
    db.version(newDbVersion).stores(databaseNewVersionToStore)
    dbStatus = await db.open().then((dbStatus) => dbStatus)

    window.sessionStorage.setItem('dbTables', JSON.stringify(databaseNewVersionToStore))
    window.sessionStorage.setItem('dbVersion', String(newDbVersion))

    for (let i = 0; i < currentDatabaseTablesLength; i++) {
      for (let h = 0; h < currentDatabaseData[currentDatabaseTables[i]].length; h++) {
        const dataObjectToAdd = currentDatabaseData[currentDatabaseTables[i]][h]

        const tableNameRequested = dbStatus.table(currentDatabaseTables[i])
        const checkIfRegistryExists =
          currentDatabaseTables[i] === '__dexie-encrypted-addon__' ? await tableNameRequested.where('id').equals(dataObjectToAdd.id).toArray() : await tableNameRequested.where('_id').equals(dataObjectToAdd._id).toArray()

        if (checkIfRegistryExists.length === 0) dbStatus.table(currentDatabaseTables[i]).add(dataObjectToAdd)
      }
    }

    if (dataToSet && Array.isArray(dataToSet)) {
      const dataObjectToAdd: any = {}
      tableKeys.split(',').map((keyName: string) => (dataObjectToAdd[keyName] = ''))

      for (let i = 0; i < dataToSet.length; i++) {
        const registryToSet: any = dataToSet[i]
        const keysOfRegistryToSet = Object.keys(dataToSet[i])

        keysOfRegistryToSet.map((keyName: string) => (dataObjectToAdd[keyName] = registryToSet[keyName]))

        const tableNameRequested = dbStatus.table(tableName)
        const checkIfRegistryExists = await tableNameRequested.where('_id').equals(dataObjectToAdd._id).toArray()

        if (checkIfRegistryExists.length === 0) dbStatus.table(tableName).add(dataObjectToAdd)
      }
    } else if (dataToSet && !Array.isArray(dataToSet)) {
      const dataObjectToAdd: any = {}
      tableKeys.split(',').map((keyName: string) => (dataObjectToAdd[keyName] = ''))

      const registryToSet: any = dataToSet
      const keysOfRegistryToSet = Object.keys(dataToSet)

      keysOfRegistryToSet.map((keyName: string) => (dataObjectToAdd[keyName] = registryToSet[keyName]))

      const tableNameRequested = dbStatus.table(tableName)
      const checkIfRegistryExists = await tableNameRequested.where('_id').equals(dataObjectToAdd._id).toArray()

      if (checkIfRegistryExists.length === 0) dbStatus.table(tableName).add(dataObjectToAdd)
    }

    await db.close()
    resolve(true)
  })
}

const handleGetCurrentDatabaseData = () => {
  return new Promise(async (resolve) => {
    const currentDatabaseData: any = {}
    const db = new Dexie('adamo-pay')

    const dbStructure = handleGetDatabaseStructure()
    const currentDbVersion = await db.open().then((dbStatus) => dbStatus.verno)
    await db.close()
    db.version(currentDbVersion).stores(dbStructure)

    const { tables } = await db.open().then((dbStatus) => dbStatus)
    const tableLength = tables.length

    for (let i = 0; i < tableLength; i++) {
      const dataFromTable = await handleGetDataFromTable(tables[i].name)
      currentDatabaseData[tables[i].name] = dataFromTable
    }

    resolve(currentDatabaseData)
  })
}

const handleGetDatabaseStructure = () => {
  const dbStructureToSet: { [keyName: string]: string | null } = {}
  const tablesNames = Object.keys(tablesHeaders)

  for (const element of tablesNames) {
    dbStructureToSet[element] = (tablesHeaders as TablesHeaders)[element as keyof TablesHeaders]?.join(', ').replaceAll(' ', '') as string

    globalThis.sessionStorage.setItem('dbTables', JSON.stringify(dbStructureToSet))
  }

  return dbStructureToSet
}
